import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { TostMsg } from "../../../App";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import $ from "jquery";
import { getTrans as T } from "../../../Shared/Language";
import {
  AddAnnouncement,
  DeleteAnnouncement,
  getAnnouncement,
} from "./Services/AnnouncementService";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.memo(
  lazy(() => import("../../../Shared/Sidebar/ComponentLoader"))
);
const defaultImage = "/images/no-data-found/announcement01.jpg";

function AnnouncementDetail() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const toster = useContext(TostMsg);
  const { GUID } = useParams();
  const [Isloading, setIsloading] = useState(false);
  const [announcementData, setAnnouncementList] = useState();
  const [announcementDeleteId, setAnnouncementDeleteId] = useState(0);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  let history = useHistory();
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [feature, setFeature] = useState(false);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  useEffect(() => {
    GetAnnouncement();
    permissionAccouncementList();
    GetMasterSystemAlertList("Announcements_header_desc", 1);
  }, []);

  const AnnouncementEdit = () => {
    history.push(`/Announcement/Edit/${GUID}`);
  };

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Announcement.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Announcement.Update") {
        setUpdate(true);
      } else if (UserPermission.PermissionName == "Announcement.Delete") {
        setDeleted(true);
      } else if (UserPermission.PermissionName == "Announcement.Upcoming") {
        setFeature(true);
      }
    });
  };

  async function GetAnnouncement() {
    setIsloading(true);
    const params = {
      Id: 0,
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      year: "",
      AnnouncementType: 0,
      FutureAnnouncement: 1,
      GUID: GUID,
      PageNumber: 1,
      PageSize: 1,
    };
    try {
      const response = await getAnnouncement(params);
      setAnnouncementList(response?.Data[0]);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
      if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  //    deleteAnnouncement functions

  async function deleteAnnouncementDetails() {
    if (announcementDeleteId) {
      let body = {
        Id: announcementDeleteId,
        ModifiedBy: userDetails?.EmpId,
      };
      setIsloading(true);
      try {
        let experiencesLists = await DeleteAnnouncement(body);
        GetMasterSystemAlertList("Announcement_deleted", 0);
        history.push(`/Announcement`);
        setIsloading(false);
        document.getElementById("delete-ed").click();
      } catch (error) {
        setIsloading(false);
      }
    }
  }

  const imageUrl = announcementData?.Image?.trim()
    ? announcementData.Image
    : defaultImage;

  const truncatedSummary = (announcementData) => {
    return announcementData?.Desc;
  };

  const fileTypes = [
    { ext: "pdf", name: "Pdf", icon: "/images/tickets/pdf.png" },
    { ext: "jpg", name: "Jpg", icon: "/images/tickets/jpg.png" },
    { ext: "jpeg", name: "Jpg", icon: "/images/tickets/jpg.png" },
    { ext: "png", name: "Png", icon: "/images/tickets/jpg.png" },
    { ext: "doc", name: "Doc", icon: "/images/tickets/doc.JPG" },
    { ext: "docx", name: "Docx", icon: "/images/tickets/doc.JPG" },
    { ext: "zip", name: "Zip", icon: "/images/tickets/zip.png" },
    { ext: "xls", name: "Excel", icon: "/images/tickets/excel.png" },
    { ext: "xlsx", name: "Excel", icon: "/images/tickets/excel.png" },
    { ext: "csv", name: "Excel CSV", icon: "/images/tickets/excel.png" },
  ];

  return (
    <>
      <div id="circular-menu" className="circular-menu position-relation">
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              stroke-linejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              stroke-linejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link href="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              stroke-linejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              stroke-linejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </Link>
        </div>
      </div>

      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="edit-ticket mb-4">
            <div className="w-100">
              <div className="row g-3">
                <div className="form-head d-flex flex-wrap align-items-center">
                  <div className="me-auto">
                    <h2 className="font-w600 mb-0">
                      {T("Announcement Detail")}
                    </h2>
                    <p className="mb-2">{masterSystemAlertData}</p>
                    <span className=" fs-7">
                      By: {announcementData?.ModifiedByName},{" "}
                    </span>
                    <span className=" fs-7">
                      On:{" "}
                      {moment(announcementData?.CreatedDate).format(
                        "MMM DD YYYY"
                      )}
                    </span>
                  </div>
                  <div className="rightside-tabs">
                    <Link to="/Announcement" className="">
                      <button className="back-newticket w-auto float-right">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="currentColor"
                          className="bi bi-arrow-left-short"
                          viewBox="0 0
 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M12 8a.5.5 0 0 1-.5.5H5.7
 07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
 .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                          ></path>
                        </svg>{" "}
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="col-xl-8">
                  <div className="card">
                    {" "}
                    <div className="card-body">
                      <img
                        src="/images/org-img/leave/popup-backimg.png"
                        className="sidefloatimg"
                        style={{ bottom: "0" }}
                        alt="Background"
                      />
                      <div className="illustration-header00">
                        <div className="header-meta">
                          {announcementData?.Image?.trim() ? (
                            <a
                              href={announcementData.Image}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                className="bannerimgcs"
                                style={{ bottom: "0" }}
                                src={imageUrl} // Use default image if empty
                                onError={handleImageError} // Handle broken images
                                width="32"
                                alt="Announcement"
                              />
                            </a>
                          ) : (
                            <img
                              className="bannerimgcs"
                              style={{ bottom: "0" }}
                              src={defaultImage} // Default image for empty values
                              width="32"
                              alt="Default Announcement"
                            />
                          )}

                          <h2 className="detailhead break-text">
                            {announcementData?.Title}
                            {update && (
                              <img
                                src="/images/tickets/edit-ico.svg"
                                className="editdivinfo"
                                title="Edit"
                                onClick={() => AnnouncementEdit()}
                                alt="Edit"
                              />
                            )}
                            {deleted && (
                              <img
                                data-toggle="tooltip"
                                data-placement="top"
                                data-bs-toggle="modal"
                                data-bs-target="#delete-ed"
                                data-bs-original-title="delete"
                                aria-label="delete"
                                src="/images/tickets/delete.svg"
                                className="editdivinfo"
                                title="Delete"
                                onClick={() =>
                                  setAnnouncementDeleteId(announcementData?.Id)
                                }
                                alt="Delete"
                              />
                            )}
                          </h2>
                          <ul className="basicinfomation mb-4">
                            <li>
                              <span className="med-pri">
                                On{" "}
                                {moment(announcementData?.Date).format(
                                  "MMM DD YYYY"
                                )}
                              </span>
                            </li>
                          </ul>
                          <div className="header-meta">
                            <h3 className="mb-3">Description</h3>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: truncatedSummary(announcementData),
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="mt-0">Attachments</h5>
                          {announcementData?.AnnouncementDocuments?.length >
                          0 ? (
                            <div className="announcement-attchment">
                              {announcementData?.AnnouncementDocuments.map(
                                (lst, index) => {
                                  const fileExt = lst?.Document?.split(".")
                                    .pop()
                                    ?.toLowerCase()
                                    .split("?")[0];
                                  const fileType = fileTypes.find(
                                    (f) => f.ext === fileExt
                                  );
                                  if (!fileType) return null;
                                  const uploaderImage =
                                    lst?.ModifiedByProfileImage &&
                                    lst?.ModifiedByProfileImage !== ""
                                      ? lst?.ModifiedByProfileImage
                                      : defaultImage;
                                  return (
                                    <div className="filediv" key={index}>
                                      <div className="file_detail">
                                        <div className="image">
                                          <img
                                            src={fileType.icon}
                                            alt={fileType.name}
                                            width="100%"
                                            style={{ borderRadius: "100%" }}
                                          />
                                        </div>
                                        <span>
                                          <h6>{fileType.name}</h6>
                                          <span className="bypersom-date">
                                            By{" "}
                                            <a
                                              href={lst?.Document}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              <img
                                                src={uploaderImage}
                                                onError={handleImageError}
                                                alt="User"
                                              />
                                              {announcementData?.ModifiedByName}
                                            </a>
                                          </span>
                                        </span>
                                      </div>

                                      <div className="ticket-file-attach__items_download">
                                        <a
                                          href={lst?.Document}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="17"
                                            height="17"
                                            fill="currentColor"
                                            className="bi bi-download"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                                          </svg>
                                        </a>
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ) : (
                            <div className="text-center">
                              <p>No Attachment Found</p>
                            </div>
                          )}

                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {Isloading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete this announcement?</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteAnnouncementDetails()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AnnouncementDetail;
